import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SwiperModule } from 'swiper/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BannerComponent } from './component/banner/banner.component';
import { HeaderComponent } from './component/header/header.component';
import { FeatureComponent } from './component/feature/feature.component';
import { TeamComponent } from './component/team/team.component';
import { RoadmapComponent } from './component/roadmap/roadmap.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FaqComponent } from './component/faq/faq.component';
import { FooterComponent } from './component/footer/footer.component';
import { HomeWrapperComponent } from './component/home-wrapper/home-wrapper.component';
import { BuyWithComponent } from './component/buy-with/buy-with.component';
import { AboutAppComponent } from './component/about-app/about-app.component';
import { CriptoRecomandationComponent } from './component/cripto-recomandation/cripto-recomandation.component';
import { ChatBotComponent } from './component/chat-bot/chat-bot.component';
import { SharedModule } from './shared/shared.module';
import { AngularMaterialModule } from './material-module';
import { LanguageComponent } from './component/language/language.component';
import { SwapComponent } from './component/swap/swap.component';
import { ConnectComponent } from './component/connect/connect.component';
import { HowToBuyComponent } from './component/how-to-buy/how-to-buy.component';
import { ReferComponent } from './component/refer/refer.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { SmartestWayComponent } from './component/smartest-way/smartest-way.component';
import player from 'lottie-web';
import { LottieModule } from 'ngx-lottie';
import { PartnerComponent } from './component/partner/partner.component';
import { AirdropComponent } from './component/airdrop/airdrop.component';
import { MarketInsightsComponent } from './component/market-insights/market-insights.component';
import { TokenComponent } from './component/token/token.component';
import { TermsComponent } from './component/terms/terms.component';
import { PrivacyComponent } from './component/privacy/privacy.component';
import { PortfolioComponent } from './component/portfolio/portfolio.component';
import { BestDexComponent } from './component/best-dex/best-dex.component';
import { BestTokenAirdropComponent } from './component/best-token-airdrop/best-token-airdrop.component';
import { ScrollAnimationDirective } from './shared/directives/scroll-animation.directive';
import { CookiesComponent } from './component/cookies/cookies.component';
import { FournotpageComponent } from './component/fournotpage/fournotpage.component';


@NgModule({
  declarations: [
    AppComponent,
    BannerComponent,
    HeaderComponent,
    FeatureComponent,
    TeamComponent,
    RoadmapComponent,
    FaqComponent,
    FooterComponent,
    HomeWrapperComponent,
    BuyWithComponent,
    AboutAppComponent,
    CriptoRecomandationComponent,
    ChatBotComponent,
    LanguageComponent,
    SwapComponent,
    ConnectComponent,
    HowToBuyComponent,
    ReferComponent,
    SmartestWayComponent,
    PartnerComponent,
    AirdropComponent,
    MarketInsightsComponent,
    TokenComponent,
    TermsComponent,
    PrivacyComponent,
    PortfolioComponent,
    BestDexComponent,
    BestTokenAirdropComponent,
    ScrollAnimationDirective,
    CookiesComponent,
    FournotpageComponent

  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    CarouselModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    HttpClientModule,
    ClipboardModule,
    LottieModule.forRoot({ player: playerFactory }),
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    AngularSvgIconModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SwiperModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '/../assets/i18n/', '.json');
}
export function playerFactory(): any {
  return import('lottie-web');
}
